import { useEffect, useState } from "react";
import { useNotification } from "@/context/NotificationContext";
import * as GuardiansV2API from "@/services/api/guardiansv2";
import { Button } from "@/components/ui/button/Button";
import { setGuardiansAlertNotificationsEnabled } from "../hooks/guardiansAlertNotificationsPref";

/** Per-user alert notification preferences. */
export function AlertNotificationsPanel() {
  const { showSuccess, showError } = useNotification();
  const [enabled, setEnabled] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    GuardiansV2API.getUserPreferences()
      .then((prefs) => {
        setEnabled(prefs.alert_notifications_enabled === true);
        setGuardiansAlertNotificationsEnabled(prefs.alert_notifications_enabled === true);
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await GuardiansV2API.patchUserPreferences({
        alert_notifications_enabled: enabled,
      });
      setGuardiansAlertNotificationsEnabled(enabled);
      showSuccess("Notification settings saved");
    } catch {
      showError("Failed to save notification settings");
    } finally {
      setSaving(false);
    }
  };

  if (!loaded) {
    return <p className="text-sm text-slate-500">Loading…</p>;
  }

  return (
    <div className="space-y-4" data-testid="alert-notifications-panel">
      <div>
        <h3 className="text-sm font-medium text-slate-200">Alert notifications</h3>
        <p className="mt-1 text-sm text-slate-400">
          When enabled, you receive an in-app notification when a screening alert rule with Notify
          turned on fails.
        </p>
      </div>
      <label className="flex cursor-pointer items-start justify-between gap-3 rounded-lg border border-white/5 bg-slate-800/40 px-3 py-2">
        <span>
          <span className="block text-sm text-slate-200">Alert notifications</span>
          <span className="block text-xs text-slate-500">Default off — enable to receive notify-enabled rule failures</span>
        </span>
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => setEnabled(e.target.checked)}
          className="mt-1 h-4 w-4 rounded border-slate-500"
          data-testid="alert-notifications-toggle"
        />
      </label>
      <Button onClick={() => void save()} disabled={saving} className="w-full">
        {saving ? "Saving…" : "Save notifications"}
      </Button>
    </div>
  );
}
